module.exports = __webpack_public_path__ + "img/welcome.b9c8bec1.svg";